import {client} from './services/client'

export  const departements = {
    namespaced:true,
    state:{
        departements:[],
        departementloading:true,
    },
    mutations: {
        SET_DEPARTEMENT (state,departements){
            state.departements = departements
        },
        SET_DEPARTEMENTLOADING (state,departements){
            state.departementloading = departements
        },
    },
    actions: {
        getDepartement({commit}){
            commit('SET_DEPARTEMENTLOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/departement/get',
                })
                    .then((response)=>{
                        let departements = response.data.departements;
                        console.log(departements);
                        commit('SET_DEPARTEMENT',departements)
                        commit('SET_DEPARTEMENTLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setDepartement({commit},data){
            commit('SET_DEPARTEMENTLOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/departement/save',
                    data:data,
                })
                    .then((response)=>{
                        let departements = response.data.departements;
                        commit('SET_DEPARTEMENT',departements);
                        commit('SET_DEPARTEMENTLOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteDepartement({commit},id){
            commit('SET_DEPARTEMENTLOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/departement/delete/'+id,
                })
                    .then((response)=>{
                        let departements = response.data.departements;
                        commit('SET_DEPARTEMENT',departements);
                        commit('SET_DEPARTEMENTLOADING',false)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getDepartement: state  => {
            return state.departements
        },
    }
};
